<!-- 
  依赖处理
  1、 yarn add snapsvg 
      yarn add imports-loader@1.2.0 --dev 
  2、 vue.config配置
      chainWebpack: config => {
        config.module
          .rule("Snap")
          .test(require.resolve("snapsvg/dist/snap.svg.js"))
          .use("imports-loader")
          .loader("imports-loader?wrapper=window&additionalCode=module.exports=0;");

        config.resolve.alias.set("snapsvg", "snapsvg/dist/snap.svg.js");
      },
-->
<template>
  <div
    id="svg-snap"
    :class=" !!fill ? 'xq-svg-box' : 'non-fill'"
    ref="boxEl"
  />
</template>

<script>
import Snap from "snapsvg";

export default {
  name: "SVGBox",
  props: {
    url: {
      type: String,
      require: true,
    },
    width: {
      type: [String, Number],
      require: true,
    },
    height: {
      type: [String, Number],
      require: true,
    },
    fill: {
      type: String,
      require: false,
    },
  },
  data() {
    return {
      snapSVG: null,
    };
  },
  watch: {
    url() {
      this.init();
    },
    width() {
      this.updateSVG();
    },
    fill() {
      this.updateSVG();
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      const _this = this;
      const { url, width, height, fill } = this;

      if (!url) return;

      Snap.load(
        url,
        function (svg) {
          this.replaceChildren(svg.node);
          const snapSVG = Snap(this.querySelector("svg"));

          if (fill) {
            snapSVG.attr({
              width,
              height,
              fill,
            });
          } else {
            snapSVG.attr({
              width,
              height,
            });
          }
          _this.snapSVG = snapSVG;
        },
        this.$refs.boxEl
      );
    },
    updateSVG() {
      if (!this.snapSVG) return;

      const { width, height, fill } = this;

      if (fill) {
        this.snapSVG.attr({
          width,
          height,
          fill,
        });
      } else {
        this.snapSVG.attr({
          width,
          height,
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.xq-svg-box {
  width: 100%;
  height: 100%;
  line-height: 0;

  ::v-deep svg {
    & path,
    & line,
    & rect,
    & circle,
    & ellipse {
      fill: inherit !important;
    }
  }
}
.non-fill {
  width: 100%;
  height: 100%;
  line-height: 0;
}
</style>
